import { AddressParseJobDto } from "types/api/addressParseJobs";
import {
  pollAgentJob,
  PollOutcome as AgentPollOutcome,
  readAgentJob,
} from "./agentJob";
import api from "./api";

// Address-parse specialisation of utils/agentJob.ts; the shared pieces the
// address panel and its tests use are re-exported.
export { isAbortError } from "./agentJob";
export { PHOTO_ACCEPT, PHOTO_MAX_BYTES, validatePhoto } from "./photoUpload";

type JobsApi = typeof api.addressParseJobs;

export type PollOutcome = AgentPollOutcome<
  AddressParseJobDto,
  "parsed" | "failed"
>;

type PollOptions = {
  signal?: AbortSignal;
  jobsApi?: JobsApi;
  intervalMs?: number;
  timeoutMs?: number;
  now?: () => number;
};

export const buildAddressParseFormData = (
  rawInput: string,
  photo: File | null,
): FormData => {
  const body = new FormData();
  const text = rawInput.trim();
  if (text) body.append("raw_input", text);
  if (photo) body.append("image", photo);
  return body;
};

export const readAddressParseJob = (response: unknown): AddressParseJobDto =>
  readAgentJob<AddressParseJobDto>(response);

export const createAddressParseJob = async (
  body: FormData,
  jobsApi: JobsApi = api.addressParseJobs,
): Promise<AddressParseJobDto> =>
  readAddressParseJob(await jobsApi.create(body));

// Terminal statuses are `parsed` and `failed`; everything else keeps polling.
export const pollAddressParseJob = (
  jobId: number,
  { jobsApi = api.addressParseJobs, ...options }: PollOptions = {},
): Promise<PollOutcome> =>
  pollAgentJob<AddressParseJobDto, "parsed" | "failed">(jobId, {
    jobsApi,
    terminalStatuses: ["parsed", "failed"],
    ...options,
  });
